import ImportantNewsCard from "./ImportantNewsCard";
import React, { useState, useEffect } from 'react';

import Right from "../../assets/icon/NewsIcons/NewsRightBold2";
import Left from "../../assets/icon/NewsIcons/NewsLeftBold2";
import moment from 'jalali-moment'

const ImportantNewsBox = ({ boxTitle, marginTop ,data}) => {


    const [startIndex, setStartIndex] = useState(0);

    const [itemsPerPage, setItemsPerPage] = useState(4);

    useEffect(() => {
        const updateItemsPerPage = () => {
            if (window.innerWidth < 1024 && window.innerWidth > 395) {
                setItemsPerPage(2);
            } else {
                if (window.innerWidth <= 395) {
                    setItemsPerPage(1);
                }
                else {
                    setItemsPerPage(4);
                }
            }
        };

        updateItemsPerPage();
        window.addEventListener('resize', updateItemsPerPage);

        return () => {
            window.removeEventListener('resize', updateItemsPerPage);
        };
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setStartIndex((prevIndex) => (prevIndex + itemsPerPage) % data?.length);
        }, 8000);

        return () => clearInterval(interval);
    }, [itemsPerPage, data?.length]);

    const handleNext = () => {
        setStartIndex((prevIndex) => (prevIndex + 1) % data.length);
    };

    const handlePrev = () => {
        setStartIndex((prevIndex) => (prevIndex - 1 + data.length) % data.length);
    };

    const displayedItems = data?.slice(startIndex, startIndex + itemsPerPage).concat(
        data?.slice(0, Math.max(0, (startIndex + itemsPerPage) - data.length))
    );  


  

    return (
        <div className={`w-[100%] flex flex-col justify-center items-start px-[120px] xl:px-[10px]  mt-[${marginTop}px]`}>
            <div className="w-full flex justify-center items-center">
                <div className="w-[28px] h-[8px] bg-nextColor rounded-[50px] shadow-yellowShadow md:h-[8px] md:w-[35px]"></div>
                <div className="w-[8px] h-[8px] mr-[5px] bg-nextColor rounded-[50px] shadow-yellowShadow md:h-[8px] md:w-[8px]"></div>
                <p className="text-[25px] text-mainColor2 font-IRANYekanExtra mx-[15px] md:text-[20px]">{boxTitle}</p>
                <div className="w-[8px] h-[8px] ml-[5px] bg-nextColor rounded-[50px] shadow-yellowShadow md:h-[8px] md:w-[8px]"></div>
                <div className="w-[28px] h-[8px] bg-nextColor rounded-[50px] shadow-yellowShadow md:h-[8px] md:w-[35px]"></div>
            </div>
            <div className="w-[98.7%] flex justify-end items-center mb-[14px] pl-[1.3%] md:mt-[20px]">
                <div className="flex justify-start items-center">
                <button  onClick={handleNext} className="w-[33px] h-[33px] bg-mainColor2 rounded-[10px] ml-[5px] flex justify-center items-center md:w-[24px] md:h-[24px] md:rounded-[5px]"><Right width="13" height="18" font="4" className="md:w-[8px]"/></button>
                <button  onClick={handlePrev} className="w-[33px] h-[33px] bg-nextColor rounded-[10px] flex justify-center items-center  md:w-[24px] md:h-[24px] md:rounded-[5px]"><Left width="13" height="18" font="4" className="md:w-[8px]"/></button>
                 </div>
            </div>
                 
            <div className="flex w-[100%] gap-[1%]  justify-center">
            {displayedItems?.map((news) => (
                    <div
                        key={news.id}
                        className="w-[23%] min-w-[190px]  h-[300px] bg-white flex flex-col rounded-md lg:w-[47%] lg:k395:w-[92%]"
                    >
                        <ImportantNewsCard
                            newsPic={news?.article?.mainPicture}
                            newsTitle={news?.article?.articleTittle}
                            newsDate={moment(news?.article?.datePublished?.split("T")[0].replace("-", "/"), 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD')} 
                            newsTime={news?.article?.datePublished?.split("T")[1].substr(0, 5)}
                            navLink={"news/"+news?.category?.categorySlug+"/"+news?.article?.slug} 
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ImportantNewsBox;
